import $ from 'jquery';

import {fetchRemoteResult} from '../../Api/api-util';
import securityApi from '../../Util/security';

const controllerEndpoint = '/JourneyBuilder/';

const validatePermission = (permissionGrantType) => {
    return securityApi.validatePermission(
        securityApi.Permissions.JourneyBuilder,
        permissionGrantType
    );
};

const serializeJourney = (journey) => {
    const journeyClone = JSON.parse(JSON.stringify(journey));
    journeyClone.bricks.forEach(brick => {
        brick.config = JSON.stringify(brick.config);
        brick.connections.forEach(connection => { connection.config = JSON.stringify(connection.config); });
    });
    
    return JSON.stringify(journeyClone);
};

let _touchpointPromise;
let _audiencePromise;
let _allAudiencePromise;
let _journeysPromise;
let _conditionsPromise;
let _audienceFilterFieldTypesPromise;
let _deduplicationFieldsPromise;
let _emailCampaignPromise;
let _steamCampaignPromise;
let _worldsPromise;
const fieldsCache = {};

export default {
    getViewJourneyUrl(journeyId) {
        return `${controllerEndpoint}Index/${journeyId}`;
    },
    getViewTouchPointStatisticsUrl(touchPointId){
        return `${controllerEndpoint}ViewTouchPointStatistics?touchPointId=${touchPointId}`;
    },
    getStatisticsPageUrl(journeyId){
        let endpoint = `${controllerEndpoint}JourneyReport/`;
        
        if(journeyId){
            endpoint += journeyId;
        }
        
        return endpoint;
    },
    getJourneyById(journeyId) {
        return fetchRemoteResult(`${controllerEndpoint}GetJourneyById/${journeyId}`);
    },
    listJourneys(){
        return fetchRemoteResult(`${controllerEndpoint}ListJourneys`);
    },
    deleteJourneyById(journeyId) {
        return fetchRemoteResult(`${controllerEndpoint}DeleteJourney/${journeyId}`);
    },
    getJourneyBrickDefinitions(){
        return fetchRemoteResult(`${controllerEndpoint}GetJourneyBrickDefinitions`);
    },
    getJourneyConditions(){
        return fetchRemoteResult(`${controllerEndpoint}GetJourneyConditions`);
    },
    publishJourney(journey){
        const opts = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: serializeJourney(journey)
        };
        
        return fetchRemoteResult(`${controllerEndpoint}Publish`, opts);
    },
    cloneJourney(journeyId){
        return fetchRemoteResult(`${controllerEndpoint}Clone/${journeyId}`, {
            method: 'POST'
        });
    },
    getBrickTrafficGeneralStatistics(destinationBrickId){
        return fetchRemoteResult(
            `${controllerEndpoint}GetBrickTrafficGeneralStatistics?brickId=${destinationBrickId}`
        );
    },
    getTouchpointTrafficStatistics(connectionId, filters){
        const queryString = '?' + $.param({
            touchpointId: connectionId,
            filters: JSON.stringify(filters)
        });
        
        return fetchRemoteResult(
            `${controllerEndpoint}GetTouchpointTrafficStatistics${queryString}`
        );
    },
    getTouchpointTypes(){
        return _touchpointPromise ? _touchpointPromise : (
            _touchpointPromise = fetchRemoteResult(`${controllerEndpoint}GetTouchPointTypes`)
        );
    },
    getTouchpointDeduplicationFields(){
        return _deduplicationFieldsPromise ? _deduplicationFieldsPromise : (
            _deduplicationFieldsPromise = fetchRemoteResult(`${controllerEndpoint}GetTouchpointDeduplicationFields`)
        );
    },
    getTouchPointParentTypes() {
        _touchpointPromise = _touchpointPromise || fetchRemoteResult(`${controllerEndpoint}GetTouchPointTypes`);

        return new Promise((resolve, reject) => {
            _touchpointPromise.then((types) => {
                const parentTypes = [];
    
                //Parent types will be all distinct touchpoint parentTypes
                types.map((type) => {
                    if(type.parentType && parentTypes.indexOf(type.parentType) === -1) {
                        parentTypes.push(type.parentType);
                    }
                });
                resolve(parentTypes);
            }, reject);
        });
    },
    getCustomConditionTypes(){
        return _conditionsPromise || (
            _conditionsPromise = fetchRemoteResult(`${controllerEndpoint}GetCustomConditionTypes`)
        );
    },
    getAudienceFilterFieldTypes(){
        return _audienceFilterFieldTypesPromise || (
            _audienceFilterFieldTypesPromise = fetchRemoteResult(`${controllerEndpoint}GetAudienceFilterFieldTypes`)
        );
    },
    getAudiences() {
        return _audiencePromise || (
            _audiencePromise = fetchRemoteResult(`${controllerEndpoint}GetAudiences`)
        );
    },
    getAllAudiences() {
        return _allAudiencePromise || (
            _allAudiencePromise = fetchRemoteResult(`${controllerEndpoint}GetAllAudiences`)
        );
    },
    
    getEmailCampaigns(){
        return _emailCampaignPromise || (
            _emailCampaignPromise = fetchRemoteResult(`${controllerEndpoint}GetEmailCampaigns`)
        );
    },
    getJourneys() {
        return _journeysPromise || (
            _journeysPromise = fetchRemoteResult(`${controllerEndpoint}ListJourneys`)
        );
    },
    getTouchPointStatistics(touchpointId) {
        return fetchRemoteResult(`${controllerEndpoint}GetTouchPointStatistics?touchPointId=${touchpointId}`);
    },
    getSteamCampaigns(){
        return _steamCampaignPromise || (
            _steamCampaignPromise = fetchRemoteResult(`${controllerEndpoint}GetSteamCampaigns`)
        );
    },
    getWorlds() {
        return _worldsPromise || (_worldsPromise = fetchRemoteResult(`${controllerEndpoint}GetWorlds`));
    },
    getCustomFields(touchPointParentType) {
        //Lazy loading of custom fields per touchpoint parent type.
        const cached = fieldsCache[touchPointParentType];
        if(cached){
            return cached;
        }
        
        return fieldsCache[touchPointParentType] = new Promise((resolve, reject) => {
            fetchRemoteResult(`${controllerEndpoint}GetCustomFields?touchPointParentType=${touchPointParentType}`)
                .then((fields) => {

                    const types = {};

                    fields.forEach((field) => {
                        //A type can be considered a 'free' field when it is encountered a single time
                        //and its value is an empty string

                        const type = types[field] || (types[field.field] = { name: field.field, isDropdown: false });
                        type.isDropdown = type.isDropdown || field.value !== '';
                    });

                    //Add to cache
                    const value = {
                        name: touchPointParentType,
                        types: Object.values(types),
                        fields: fields
                    };
                    
                    console.log(value);

                    resolve(value); //Resolve api result.
                }, function(){
                    //Error; remove our failed promise from the cache 
                    delete fieldsCache[touchPointParentType];
                    reject.apply(this, ...arguments);
                });
        });
    },
    validateWritePermission(){
        return validatePermission(securityApi.PermissionGrantTypes.Write);
    },
    validateDeletePermission(){
        return validatePermission(securityApi.PermissionGrantTypes.Delete);
    }
};

export {
    controllerEndpoint      
};